import { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Header from "layouts/profile/components/Header";
import AuthService from "services/AuthService";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar, TextField } from "@mui/material";
import UserService from "services/UserService";
import MuiAlert from "@mui/material/Alert";

function Overview() {
  const [user, setUser] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [open, setOpen] = useState(false);
  const [alert, setAlert] = useState({ type: '', message: '' });
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = AuthService.getCurrentUser();
    setUser({
      ...currentUser,
      newName: currentUser.Name,
      newPassword: '',
      confirmPassword: '', 
    });

  }, [refresh]);

  const passwordCompare = (value) => user.newPassword === value;

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const isUserEdit = (newName, newPassword) => (newName !== user.Name || newPassword.length !== 0) ? true : false

  const handleUserEdited = ({ newName, newPassword, confirmPassword }) => {
    setUser({...user, newName: newName, newPassword: newPassword, confirmPassword: confirmPassword})

    if (isUserEdit(newName, newPassword)) {
      setIsEdit(true)
    } else {
      setIsEdit(false)
    }
  }

  const handlePasswordReset = async (e) => {
    e.preventDefault();

    if (!passwordCompare(user.confirmPassword)) {
      setAlert({type:'error', message:'As senhas devem ser iguais!'});
      setOpen(true);
      return;
    }

    if (!isEdit) {
      return;
    }

    try {
      let editUser = { Name: user.newName, Email: user.Email, Main: user.Main, SupplierId: user.SupplierId.toString(), RoleId: user.Role.Id, Password: user.newPassword };
      const Id = user.Id;

      console.log(editUser);

      if (!user.newPassword) {
        delete editUser.Password;
      }

      await UserService
        .editUser(Id, editUser, false)
        .then((res) => {
          AuthService.fetchAndStoreUserData();
          const userData = res.data.data[0];
          setUser({...userData, newName: userData.Name, newPassword: '', confirmPassword: ''});
          setIsEdit(false);
        })
        .catch((e) => { 
          throw e;
        });
      setAlert({type:'success', message:'Dados salvos!'});
      setOpen(true);
    } catch (error) {
      setAlert({type:'error', message:`Erro ao atualizar dados: ${error.response.data.error}`});
      setOpen(true);
      console.error("Erro ao atualizar dados:", error);
    }
    
  };

  const snackBar = (
    <Snackbar open={open} autoHideDuration={2000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <MuiAlert onClose={handleClose} severity={alert.type} sx={{ width: "100%" }}>
        {alert.message}
      </MuiAlert>
    </Snackbar>
  )

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} sx={{height: "90%"}} />
      <Header snackBar={snackBar} customTitle={"Editar perfil"} >
              <MDBox mt={5}>
                <TextField
                  fullWidth
                  label="Nome"
                  type="text"
                  variant="outlined"
                  value={user.newName}
                  onChange={(e) => handleUserEdited({ ...user, newName: e.target.value })}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  variant="outlined"
                  value={user.Email}
                  disabled={true}
                  contentEditable={false}
                  tabIndex={-1}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Senha"
                  type="password"
                  variant="outlined"
                  value={user.newPassword}
                  onChange={(e) => handleUserEdited({ ...user, newPassword: e.target.value })}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Confirmar Senha"
                  type="password"
                  variant="outlined"
                  value={user.confirmPassword}
                  onChange={(e) => handleUserEdited({ ...user, confirmPassword: e.target.value })}
                  sx={{ mb: 2 }}
                />
                <Button variant="contained" onClick={handlePasswordReset} disabled={!isEdit} >
                  <MDBox color='white'>Salvar</MDBox>
                </Button>
              </MDBox>
      </Header>
      {snackBar}
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
